// extracted by mini-css-extract-plugin
export default {"wrap":"FJ-z","subtitle":"GJ-z","contentWrap":"HJ-z","imgWrap":"IJ-z","heading":"JJ-z","copy":"KJ-z"};